export enum ESupportTicketStatusType {
  Done = 'resolved',
  Progress = 'in_process',
  Declined = 'refused',
}
export enum ESupportTicketStateType {
  Done = 'has_respond',
  Pending = 'no_respond',
}
